import API from "../../Data/Domain/API";
import URL from "../../Data/Domain/URL";

export async function getCommissions(params) {
  return await new API(URL.setParams(URL.buildUrl("fees"), params)).get();
}
